import { render, staticRenderFns } from "./DataViewSidebarRegions.vue?vue&type=template&id=178655e0&scoped=true&"
import script from "./DataViewSidebarRegions.vue?vue&type=script&lang=js&"
export * from "./DataViewSidebarRegions.vue?vue&type=script&lang=js&"
import style0 from "./DataViewSidebarRegions.vue?vue&type=style&index=0&id=178655e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178655e0",
  null
  
)

export default component.exports